module.exports = __webpack_public_path__ + "static/media/hyde_park_message.57c4d9c2.jpg";